import BankExportListViewModel from "../bankExportListViewModel";
import { computed } from "mobx";
import BankExportRepository from "repositories/bankExportRepository";
import SecurityService from "services/securityService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import OptionsService from "services/optionsService";
import download from "downloadjs";
import { getBankExportFilename } from "../utils";
import { Router } from "@frui.ts/screens";
import DistributorRefundExportDetailViewModel from "./distributorRefundExportDetailViewModel";
import parseFileNameFromAxiosResponse from "utils/parseFileNameFromAxiosResponse";
import type DistributorRefundExportResponse from "entities/distributorRefundExportResponse";

const navigationName = "distributor-refunds-exports";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [DistributorRefundExportDetailViewModel],
})
export default class DistributorRefundExportsListViewModel extends BankExportListViewModel<DistributorRefundExportResponse> {
  @computed
  get name() {
    return this.translate("distributorRefundExports");
  }

  constructor(
    protected detailViewModelFactory: ReturnType<typeof DistributorRefundExportDetailViewModel.Factory>,
    public repository: BankExportRepository,
    public securityService: SecurityService,
    public eventBus: EventBus,
    public localizationService: LocalizationService,
    public notificationService: NotificationService,
    public optionsService: OptionsService
  ) {
    super(repository, securityService, eventBus, localizationService, notificationService, optionsService);
    this.navigationName = navigationName;
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.allDistributorRefundExports({ offset, limit }, this.appliedFilter);
  }

  async download(item: DistributorRefundExportResponse) {
    try {
      if (this.allowToDownload) {
        this.fileResponse = await this.repository.getDistributorRefundExportReport(item.id);
        download(
          this.fileResponse.data,
          parseFileNameFromAxiosResponse(this.fileResponse, getBankExportFilename(item)),
          "application/zip"
        );
      }
    } catch (exc) {}
  }
}
